<!-- 購入金額 -->
<template>
  <div class="row">
    <div class="th cell">購入金額</div>
    <div class="cell">
      <strong style="font-size: 25px">{{ totalPrice.toLocaleString() }}</strong
      >円
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreTicketPrice",
  props: {
    totalPrice: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
strong {
  font-size: 13px;
}
</style>
